<template>
  <div class="home-page">
    
    <van-nav-bar :border="false">
      <template #left>
        <van-image src="img/home/logo3.png?v=2" width="130" height="43" fit="contain"></van-image>
      </template>
    </van-nav-bar>

    <div id="content">
      <div class="plCard">
        <div class="title">{{ $t('index.live_feed') }}</div>
        <swiper class="pl_swiper" :options="plOption">
          <swiper-slide v-for="(v, key) in plListText" :key="key">{{ v }}</swiper-slide>
        </swiper>
      </div>

      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>

      <div class="content">
        <div class="txt">
          <span> HOT </span>
          <span class="icon">{{ $t('index.title1') }}</span>
        </div>
        <div class="swiper_wrap">
          <div class="swiper" :style="{ width: `calc(${8.5 * xuanfeiList.length}rem)` }">
            <div v-for="item in xuanfeiList" :key="item.id" class="swipe" @click="goDetail(item)">
              <van-image :src="item.img_url[0]" fit="cover"></van-image>
              <div class="tip">
                <span>{{ $t('index.tip1') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title2') }}</div>
        <div class="ganeGroup">
          <div class="gameItem" v-for="item in gameList" :key="item.id" @click="goGame(item)">
            <div class="image">
              <van-image :src="item.ico" fit="contain"></van-image>
            </div>
            <div class="label">{{ item.name }}</div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title3') }}</div>
        <div class="xuanfeiList">
          <div class="row" v-for="item in xuanfeiList" :key="item.id" @click="goDetail(item)">
            <div class="photo">
              <van-image :src="item.img_url[0]" fit="cover"></van-image>
            </div>
            <div class="body">
              <div class="head">
                <div class="name">{{ item.xuanfei_name }}</div>
                <div class="tip">
                  <span>{{ $t('index.tip2') }}</span>
                </div>
              </div>
              <div class="renzheng">
                <div>{{ $t('index.icon1') }}</div>
                <div>{{ $t('index.icon2') }}</div>
              </div>
              <div class="biaoqian">
                <div v-for="(biaoqian, index) in item.type.slice(0, 3)" :key="index">{{ biaoqian.name }}</div>
              </div>
              <div class="xingji">
                <div>
                  <span>{{ $t('index.label1') }}：</span>
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                </div>
              </div>
              <div class="info">
                <div>{{ item.info }}</div>
              </div>
              <div class="button2">{{ $t('index.button') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      tuis: [
        {
          id: 1,
          num: '001',
          name: '',
          pic: require("@/assets/imgs/index_pic/1.jpg"),
          avatar: require("@/assets/imgs/index_avatar/11.jpg"),
          sui: '22yo / 165cm / 46kg'
        },
        {
          id: 2,
          num: '002',
          name: '',
          pic: require("@/assets/imgs/index_pic/2.jpg"),
          avatar: require("@/assets/imgs/index_avatar/12.jpg"),
          sui: '26yo / 170cm / 53kg'
        },
        {
          id: 3,
          num: '003',
          name: '',
          pic: require("@/assets/imgs/index_pic/3.jpg"),
          avatar: require("@/assets/imgs/index_avatar/13.jpg"),
          sui: '21yo / 169cm / 51kg'
        },
        {
          id: 4,
          num: '004',
          name: '',
          pic: require("@/assets/imgs/index_pic/4.jpg"),
          avatar: require("@/assets/imgs/index_avatar/14.jpg"),
          sui: '23yo / 165cm / 49kg'
        },
        {
          id: 5,
          num: '005',
          name: '',
          pic: require("@/assets/imgs/index_pic/5.jpg"),
          avatar: require("@/assets/imgs/index_avatar/15.jpg"),
          sui: '25yo / 167cm / 50kg'
        },
        {
          id: 6,
          num: '006',
          name: '',
          pic: require("@/assets/imgs/index_pic/6.jpg"),
          avatar: require("@/assets/imgs/index_avatar/16.jpg"),
          sui: '22yo / 162cm / 47kg'
        },
        {
          id: 7,
          num: '007',
          name: '',
          pic: require("@/assets/imgs/index_pic/7.jpg"),
          avatar: require("@/assets/imgs/index_avatar/17.jpg"),
          sui: '34yo / 170cm / 54kg'
        },
        {
          id: 8,
          num: '008',
          name: '',
          pic: require("@/assets/imgs/index_pic/8.jpg"),
          avatar: require("@/assets/imgs/index_avatar/18.jpg"),
          sui: '30yo / 166cm / 49kg'
        },
        {
          id: 9,
          num: '009',
          name: '',
          pic: require("@/assets/imgs/index_pic/9.jpg"),
          avatar: require("@/assets/imgs/index_avatar/19.jpg"),
          sui: '24yo / 172cm / 52kg'
        },
        {
          id: 10,
          num: '010',
          name: '',
          pic: require("@/assets/imgs/index_pic/10.jpg"),
          avatar: require("@/assets/imgs/index_avatar/20.jpg"),
          sui: '22yo / 168cm / 49kg'
        }
      ],
      bannerSwiperOption: {
        autoplay: true,
      },
      xuanfeiList: [],
      gameList: [],
      plList: [
        { name: 'jx***ib', type: 'signed' },
        { name: '95***8f', type: 'signed' },
        { name: '71***8c', type: 'matched' },
        { name: 'xf***45', type: 'matched' },
        { name: 'rw***32', type: 'matched' },
        { name: '5n***8m', type: 'matched' },
        { name: 'bv***f3', type: 'signed' },
        { name: '44***uc', type: 'signed' },
        { name: 'xo***n0', type: 'matched' },
        { name: 'xm***19', type: 'signed' },
        { name: 'ha***2g', type: 'matched' },
        { name: 'or***ze', type: 'matched' },
        { name: 'df***ux', type: 'matched' },
        { name: 'zb***is', type: 'matched' },
        { name: 'ud***c3', type: 'signed' },
        { name: 'n8***42', type: 'signed' },
        { name: 'm3***r8', type: 'signed' },
        { name: 'p1***5a', type: 'signed' },
        { name: 'ab***9e', type: 'signed' },
        { name: '0v***dz', type: 'signed' },
        { name: 'jx***ib', type: 'signed' },
        { name: '95***8f', type: 'signed' },
        { name: '71***8c', type: 'matched' },
        { name: 'xf***45', type: 'matched' },
        { name: 'rw***32', type: 'matched' },
        { name: '5n***8m', type: 'matched' },
        { name: 'bv***f3', type: 'signed' },
        { name: '44***uc', type: 'signed' },
        { name: 'xo***n0', type: 'matched' },
        { name: 'xm***19', type: 'signed' }
      ],
      plOption: {
        autoplay: true,
        direction: 'vertical',
        slidesPerView: 1,
        speed: 800,
      }
    }
  },
  computed: {
    swipeWidth() {
      return window.innerWidth * 0.45
    },
    plListText() {
      return this.plList.map(item => {
        const key = item.type === 'matched' ? 'index.live_matched' : 'index.live_signed';
        return this.$t(key, { name: item.name });
      });
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.banners = res.data?.banners || [];
      })

    },

    getXuanfeiList() {
      this.$http({
        method: 'get',
        url: 'xuanfei_list'
      }).then(res => {
        if (res.code === 200) {
          this.xuanfeiList = res.data.data.map(item => {
            item.info = `Height: ${item.height}cm  Size: ${item.bust}  Available Area: ${item.diqu}`
            return item
          })
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

    goDetail(e) {
      localStorage.setItem('xuanfeiDetail', JSON.stringify(e))
      this.$router.push(`XuanfeiDetail`);
    },

    goGame(e) {
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/WindowLottery?key='+e.key+"&id="+e.id})
      }
    },

    
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameList = res.data;
      })
    },
  },
  created() {
    this.getBasicConfig();
    this.getGameItem()
    this.getXuanfeiList()
  }
}
</script>


<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.home-page {
  min-height: 100%;
  background: @bg-page;
}

.home-page .van-nav-bar {
  background: linear-gradient(120deg, rgba(243, 156, 190, 0.95) 0%, rgba(189, 160, 240, 0.95) 55%, rgba(255, 178, 145, 0.95) 100%);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 0.2rem 0.8rem rgba(183, 156, 236, 0.15);
}
.home-page ::v-deep .van-nav-bar__left {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 0.6rem;
  .van-image {
    border-radius: 0.25rem;
    overflow: hidden;
  }
}

#content{
  padding-bottom: 3.2rem;
}

.banner {
  padding: 0;
}

.banner_swiper {
  // padding-top: 5%;
  height: 100%;
  width: 100%;
  border-radius: 0 0 1.8rem 1.8rem;
  overflow: hidden;
  box-shadow: 0 0.6rem 1.6rem rgba(183, 156, 236, 0.22);

  .swiper-slide {
    // border-radius: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 19.375rem;
    width: 100%;
    height: 13rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.625rem;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  .banner_img {
    border-radius: 0;
    width: 100%;
    height: 13rem;
    ::v-deep .van-image__img {
      width: 100%;
      height: 13rem;
      object-fit: cover;
    }
  }
}

.plCard{
  width: 92%;
  margin: 0.7rem auto 0.85rem;
  height: auto;
  padding: 0.45rem 0.85rem;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 0.25rem 0.8rem rgba(183, 156, 236, 0.14);
  display: flex;
  align-items: center;
  .title{
    flex-shrink: 0;
    margin: 0 0.7rem 0 0;
    padding: 0.12rem 0.55rem;
    border-radius: @radius-pill;
    background: @grad-primary;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.02rem;
    font-size: 0.72rem;
    line-height: 1.4;
  }
  .pl_swiper{
    flex: 1;
    height: 1.5rem;
    min-width: 0;
  }
  .swiper-slide {
    text-align: left;
    color: #6f6283;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.82rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.content {
  width: 92%;
  margin: 0 auto;

  .txt {
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.02rem;
    color: @text-title;
    margin-top: 1.25rem;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    .icon{
      display: inline-block;
      margin-left: auto;
      border-radius: @radius-pill;
      background: @grad-pink-lavender;
      color: #fff;
      font-weight: 500;
      padding: .12rem .65rem;
      font-size: 0.78rem;
      box-shadow: 0 0.2rem 0.6rem rgba(245, 154, 184, 0.3);
    }
  }


  .swiper_wrap {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .swiper {
      display: flex;
      scroll-snap-type: x mandatory;

      .swipe {
        flex-shrink: 0;
        scroll-snap-align: start;
        width: 7.8rem;
        height: 11.2rem;
        overflow: hidden;
        margin-right: .67rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 1.15rem;
        border: 2px solid rgba(255, 255, 255, 0.9);
        box-shadow: @shadow-soft;

        ::v-deep .van-image__img {
          border-radius: 1.15rem;
        }

        ::v-deep .van-image {
          width: 100%;
          height: 100%;
        }
        ::v-deep .van-image__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 1.15rem;
        }

        .tip {
          position: absolute;
          z-index: 9;
          left: 0.4rem;
          bottom: 0.4rem;
          width: fit-content;
          max-width: calc(100% - 0.8rem);
          background: @grad-peach;
          color: #fff;
          height: auto;
          border-radius: 0.7rem;
          padding: 0.12rem 0.4rem;
          span {
            position: static;
            display: block;
            font-size: .66rem;
            font-weight: 600;
            line-height: 1.25;
            white-space: normal;
            text-align: center;
          }
        }
      }
    }
  }

  .xuanfeiList {
    .row {
      display: flex;
      align-items: stretch;
      gap: 0.7rem;
      width: 100%;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.86);
      border-radius: 1.3rem;
      box-shadow: 0 0.5rem 1.4rem rgba(183, 156, 236, 0.16);
      padding: 0.65rem;
      margin-bottom: 0.95rem;

      /* 竖屏图：左侧固定宽度，高度跟随文字区拉伸 */
      .photo {
        position: relative;
        flex: 0 0 auto;
        width: 8.6rem;
        min-height: 11rem;
        border-radius: 1rem;
        overflow: hidden;

        ::v-deep .van-image,
        ::v-deep .van-image__img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .body {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;
        padding: 0.1rem 0.15rem 0.1rem 0;

        .head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.4rem;
          margin-bottom: 0.35rem;
        }

        .name {
          color: @text-title;
          font-size: 1rem;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .tip {
          flex-shrink: 0;
          background: @grad-peach;
          color: #fff;
          border-radius: 1rem;
          padding: 0.12rem 0.5rem;
          font-size: 0.68rem;
          font-weight: 600;
        }

        .renzheng {
          display: flex;
          flex-wrap: wrap;
          gap: 0.35rem 0.4rem;

          >div {
            background: linear-gradient(120deg, @lavender-light, @peach-light);
            border: 1px solid rgba(183, 156, 236, 0.45);
            color: #8a63c9;
            font-weight: 600;
            padding: .16rem .45rem;
            font-size: .73333rem;
            border-radius: @radius-pill;
            display: flex;
            align-items: center;

            &::before {
              content: '';
              width: .8125rem;
              height: .8125rem;
              background: url('/public/img/home/icon.png');
              background-size: 100% 100%;
            }
          }
        }

        .biaoqian {
          display: flex;
          flex-wrap: wrap;
          padding: 0.45rem 0 0.2rem;

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: .2rem .5rem;
            margin: 0 .4rem .35rem 0;
            border-radius: @radius-pill;
            font-size: .76667rem;

            &:nth-child(1n) {
              background-color: #ffeaf1;
              color: #e0739b;
              border: 1px solid rgba(245, 154, 184, 0.6);
            }

            &:nth-child(2n) {
              background-color: #fff0e7;
              color: #e8895c;
              border: 1px solid rgba(255, 184, 148, 0.7);
            }

            &:nth-child(3n) {
              background-color: #f2ecff;
              color: #8a63c9;
              border: 1px solid rgba(183, 156, 236, 0.6);
            }
          }
        }

        .xingji {
          color: @text-body;
          font-size: .9rem;
          padding: 0.15rem 0 0.35rem;
        }

        .info > div {
          font-size: .88rem;
          line-height: 1.45;
          color: @text-sub;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .button2 {
          width: fit-content;
          margin: auto 0 0 auto;
          padding: 0.4rem 1.15rem;
          text-align: center;
          background: @grad-primary;
          box-shadow: 0 0.25rem 0.8rem rgba(245, 154, 184, 0.3);
          font-weight: 500;
          color: #fff;
          border-radius: @radius-pill;
        }
      }
    }
  }

  .ganeGroup{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.7rem;
    background: transparent;
    box-shadow: none;
    padding: 0;
    .gameItem{
      background: rgba(255, 255, 255, 0.86);
      border-radius: 1.1rem;
      box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.14);
      padding: 0.75rem 0.5rem 0.7rem;
      text-align: center;
    }
    .image{
      width: 4.6rem;
      height: 4.6rem;
      margin: 0 auto;
    }
    .label{
      font-size: 0.92rem;
      padding-top: .45rem;
      font-weight: 600;
      color: @text-title;
      line-height: 1.3;
    }
    .van-image{
      width: 100%;
      height: 100%;
    }
  }
}
</style>